"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _storage = _interopRequireDefault(require("@aws-amplify/storage"));

var _uuidV = _interopRequireDefault(require("uuid-v4"));

var _reactImageCrop = _interopRequireDefault(require("react-image-crop"));

require("react-image-crop/dist/ReactCrop.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getCroppedImg = function getCroppedImg(image, crop) {
  var canvas = document.createElement('canvas');
  var scaleX = image.naturalWidth / image.width;
  var scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  var ctx = canvas.getContext('2d');
  ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height); // As a blob

  return new Promise(function (resolve, reject) {
    canvas.toBlob(function (blob) {
      resolve({
        blob: blob,
        data: canvas.toDataURL('image/jpeg')
      });
    }, 'image/jpeg');
  });
};

var initialState = {
  uploading: false,
  photoData: null,
  photoUrl: null,
  croppedData: null,
  croppedBlob: null,
  rawFile: null
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'upload':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: true
      });

    case 'read':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false
      }, action.payload);

    case 'crop':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false
      }, action.payload);

    case 'uploaded':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploading: false
      }, action.payload);

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      throw new Error();
  }
};

var PhotoUpload = function PhotoUpload(_ref) {
  var onUpload = _ref.onUpload,
      onRead = _ref.onRead,
      photoUrl = _ref.photoUrl,
      doPrompt = _ref.doPrompt,
      skipCrop = _ref.skipCrop;
  var inputEl = (0, _react.useRef)(null);

  var _useReducer = (0, _react.useReducer)(reducer, _objectSpread(_objectSpread({}, initialState), {}, {
    photoUrl: photoUrl
  })),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useState = (0, _react.useState)({
    unit: '%',
    x: 0,
    width: 100,
    height: 100,
    y: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      crop = _useState2[0],
      setCrop = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      croppingImage = _useState4[0],
      setCroppingImage = _useState4[1];

  var _handleCrop = function _handleCrop() {
    return getCroppedImg(croppingImage, crop).then(function (cropped) {
      return dispatch({
        type: 'crop',
        payload: {
          croppedData: cropped.data,
          croppedBlob: cropped.blob
        }
      });
    });
  };

  var _handleSelect = function _handleSelect(evt) {
    return Promise.resolve({
      reader: new FileReader(),
      file: evt.target.files[0]
    }).then(function (_ref2) {
      var reader = _ref2.reader,
          file = _ref2.file;
      return new Promise(function (resolve) {
        // reader.onload = e => resolve(dispatch({type: 'read', payload: {photoData: r.result}}))
        reader.onload = function (e) {
          return loadImage(e.target.result, function (img) {
            return img.toBlob(function (blob) {
              var r = new FileReader();
              r.readAsDataURL(blob);

              r.onloadend = function () {
                return resolve(dispatch({
                  type: 'read',
                  payload: {
                    photoData: r.result,
                    rawFile: file
                  }
                }));
              };
            });
          }, {
            orientation: true
          });
        };

        reader.readAsDataURL(file);
      });
    });
  };

  var _handleUpload = function _handleUpload() {
    return [dispatch({
      type: 'upload'
    }), _storage["default"].put("".concat(1, "-", (0, _uuidV["default"])()), state.croppedBlob || state.rawFile, {
      contentType: 'image/jpeg'
    }).then(function (_ref3) {
      var key = _ref3.key;
      return _storage["default"].get(key);
    }).then(function (url) {
      return dispatch({
        type: 'uploaded',
        payload: {
          photoUrl: url.split("?")[0]
        }
      });
    })["catch"](console.log)];
  };

  (0, _react.useEffect)(function () {
    !!state.photoUrl && state.photoUrl !== photoUrl && onUpload(state.photoUrl);
  }, [state.photoUrl]);
  (0, _react.useEffect)(function () {
    !!doPrompt && !!inputEl && !state.photoData && inputEl.current.click();
  }, [doPrompt, inputEl]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    style: {
      visibility: 'hidden'
    },
    type: "file",
    ref: inputEl,
    accept: ".jpg, .jpeg, .png",
    onChange: _handleSelect
  }), !!state.photoData && !state.croppedData && !skipCrop && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactImageCrop["default"], {
    src: state.photoData,
    crop: crop,
    onChange: function onChange(crop) {
      return setCrop(crop);
    },
    onImageLoaded: setCroppingImage
  }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    fullWidth: true,
    variant: 'contained',
    color: "secondary",
    onClick: _handleCrop
  }, "Crop")), (!!state.croppedData || !!skipCrop && !!state.photoData) && !state.photoUrl && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    src: state.croppedData || state.photoData,
    alt: "Upload",
    style: {
      maxWidth: '100%',
      height: 'auto'
    }
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: !!state.uploading,
    fullWidth: true,
    variant: 'contained',
    color: "secondary",
    onClick: _handleUpload
  }, !!state.uploading ? "Uploading" : "Upload")), !!state.photoUrl && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    src: state.photoUrl,
    alt: "Uploaded",
    style: {
      maxWidth: '100%',
      height: 'auto'
    }
  })), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    fullWidth: true,
    disabled: !!state.uploading,
    variant: "outlined",
    color: "secondary",
    onClick: function onClick() {
      return [dispatch({
        type: 'reset'
      }), inputEl.current.click()];
    }
  }, "Change Photo")), !state.photoData && !state.photoUrl && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    fullWidth: true,
    variant: 'contained',
    color: "secondary",
    onClick: function onClick() {
      return inputEl.current.click();
    }
  }, "Select Logo"));
};

var _default = PhotoUpload;
exports["default"] = _default;